import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { SUB } from "@/constants/testIds";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/subscribe", { email });
      toast.success("You're on the list — we'll ping you on launch day.");
      setEmail("");
    } catch (e) {
      toast.error("Couldn't subscribe. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="border-t border-white/10 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid lg:grid-cols-2 gap-10">
        <div>
          <div className="font-mono text-xs uppercase tracking-widest text-slate-500">// Dispatch updates</div>
          <h3 className="font-display text-2xl sm:text-3xl font-black uppercase tracking-tight mt-2 max-w-md">
            Not ready to pledge? Just <span className="text-kinetic">watch us go.</span>
          </h3>
          <p className="text-slate-400 mt-3 max-w-lg">
            Get a short email when the first van hits the road, the launch wall is painted, and when early-customer credits open.
          </p>
          <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md">
            <Input
              data-testid={SUB.email}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@domain.com"
              type="email"
              required
              className="h-11 rounded-none bg-slate-900 border-white/15"
            />
            <Button
              data-testid={SUB.submit}
              disabled={busy}
              className="h-11 rounded-none bg-kinetic hover:bg-[#FF5E1A] text-black font-bold uppercase tracking-wide"
            >
              {busy ? "Signing..." : "Keep me posted"}
            </Button>
          </form>
        </div>
        <div className="lg:text-right flex flex-col lg:items-end justify-between gap-6">
          <div>
            <div className="font-display font-black text-2xl">RALLY<span className="text-kinetic">.</span></div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mt-1">
              Courier · Logistics · Founder-led
            </div>
          </div>
          <div className="font-mono text-xs text-slate-500">
            © 2026 Rally Courier. Fundraising operates in test mode until Stripe is claimed.
          </div>
        </div>
      </div>
    </footer>
  );
}
